import React, { useState, useEffect } from 'react';
import { DmsPage, DmsTabber, DmsAltBox, fetchData, HTTP_STATUS, intl, havePermissions } from 'dmsbasereact';
import { Typography, CircularProgress, Box } from '@mui/material';
import { CheckinCheckoutForm } from '../../components/CheckinCheckoutForm/CheckinCheckoutForm';
import { CheckinTable } from '../../components/CheckinCheckoutForm/CheckinTable';
import { Permissions } from '../../constants/Permissions';

export const CheckinCheckoutPage = () => {
    const [organizationBranches, setOrganizationBranches] = useState([]);
    const [batches, setBatches] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const hasCheckout = havePermissions(Permissions.STOCK_CHECKOUT);

    useEffect(() => {
        if (!hasCheckout) return;

        const fetchInitialData = async () => {
            setIsLoading(true);
            try {
                const [branchesResponse, batchesResponse] = await Promise.all([
                    fetchData('/institution/approved-branches', 'GET', true),
                    fetchData('/batch/all', 'GET', true)
                ]);

                if (branchesResponse.status === HTTP_STATUS.OK_200) {
                    setOrganizationBranches(branchesResponse.data.data || []);
                }

                if (batchesResponse.status === HTTP_STATUS.OK_200) {
                    setBatches(batchesResponse.data.data || []);
                }

            } catch (error) {
                console.error("Failed to fetch initial data", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchInitialData();
    }, [hasCheckout]);

    const tabs = [];

    if (havePermissions(Permissions.STOCK_CHECKIN)) {
        tabs.push({
            title: intl.get("Check-in").d("Check-in"),
            component: <CheckinTable />
        });
    }

    if (hasCheckout) {
        tabs.push({
            title: intl.get("Check-out").d("Check-out"),
            component: isLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <CheckinCheckoutForm organizationBranches={organizationBranches} batches={batches} mode="checkout" />
            )
        });
    }

    return (
        <DmsPage name={intl.get("CheckInCheckOut").d("Check-in / Check-out")}>
            <DmsAltBox.Card>
                <DmsAltBox.Header>
                    <Typography variant='h3' sx={{ fontSize: '1.1rem' }}>
                        {intl.get("InvoiceDocumentMovement").d("Invoice Document Movement")}
                    </Typography>
                </DmsAltBox.Header>
                <DmsAltBox.Body sx={{ overflow: 'auto' }}>
                    <DmsTabber tabs={tabs} pageName={intl.get("CheckInCheckOut").d("Check-in / Check-out")} />
                </DmsAltBox.Body>
            </DmsAltBox.Card>
        </DmsPage>
    );
};
